const s = {
  name: "Passport",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M26,7H6V5h20V7z"/>
		<path class="st0" d="M11,11h10V9H11V11z"/>
		<path class="st0" d="M18,34v2h-4v-2H18z"/>
		<path class="st0" d="M7,23c0,5,4,9,9,9c5,0,9-4,9-9s-4-9-9-9C11,14,7,18,7,23z M9.1,22c0.3-2.4,1.9-4.4,4-5.4
			c0,0.1-0.1,0.2-0.1,0.4c-0.5,1.4-0.8,3.1-0.9,5H9.1z M9.1,24h3c0.1,1.9,0.4,3.7,0.9,5c0,0.1,0.1,0.2,0.1,0.4
			C11,28.4,9.4,26.4,9.1,24z M14,24h4c-0.1,1.7-0.4,3.2-0.8,4.3c-0.2,0.7-0.5,1.1-0.8,1.4C16.2,30,16,30,16,30c0,0-0.2,0-0.4-0.3
			c-0.2-0.3-0.5-0.7-0.8-1.4C14.4,27.2,14.1,25.7,14,24z M20,24h3c-0.3,2.4-1.9,4.4-4,5.4c0-0.1,0.1-0.2,0.1-0.4
			C19.6,27.7,19.9,25.9,20,24z M22.9,22h-3c-0.1-1.9-0.4-3.7-0.9-5c0-0.1-0.1-0.2-0.1-0.4C21,17.6,22.6,19.6,22.9,22z M18,22h-4
			c0.1-1.7,0.4-3.2,0.8-4.3c0.2-0.7,0.5-1.1,0.8-1.4C15.8,16,16,16,16,16c0,0,0.2,0,0.4,0.3c0.2,0.3,0.5,0.7,0.8,1.4
			C17.6,18.8,17.9,20.3,18,22z"/>
		<path class="st0" d="M0,0h27c2.8,0,5,2.2,5,5v30c0,2.8-2.2,5-5,5H0V0z M2,2v36h25c1.7,0,3-1.3,3-3V5c0-1.7-1.3-3-3-3H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Passport
};
